<template>
  <div class="setting">
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="专题轮播图"
        name="first"
      >
        <Swiper></Swiper>
      </el-tab-pane>
      <el-tab-pane
        label="专题列表"
        name="two"
      >
        <list ref="list"></list>
      </el-tab-pane>
      <el-tab-pane
        label="专题分类"
        name="three"
      >
        <category ref="category"></category>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import list from './index'
import category from './topicCategory'
import Swiper from './Swiper'

export default {
  name: 'setting',
  components: {
    list,
    category,
    Swiper
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  watch: {
    activeName: {
      handler (value) {
        if (value === 'first') {
          this.$refs.list.getTopic()
          this.$refs.list.getTags()
        } else {
          this.$refs.category.getList()
        }
      }
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.setting {
}
</style>



// WEBPACK FOOTER //
// src/views/topic/index2.vue